/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBearLeft2 = createReactComponent("outline", "arrow-bear-left-2", "IconArrowBearLeft2", [["path", { "d": "M9 3h-5v5", "key": "svg-0" }], ["path", { "d": "M4 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93", "key": "svg-1" }], ["path", { "d": "M20 5l-4.5 4.5", "key": "svg-2" }]]);

export { IconArrowBearLeft2 as default };
//# sourceMappingURL=IconArrowBearLeft2.mjs.map
